import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import { useNumberFormatter } from 'src/hooks/useNumberFormatter';

export type Scorer = {
  name: string;
  id: string;
  points: number;
};

type ScoreRowProps = {
  scorer: Scorer;
  idx: number;
};

const SX_ROW_GROUP = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-start',
  height: '100%',
};

const POSITION_TO_COLOR = {
  0: 'gold',
  1: 'silver',
  2: '#B08D57',
};

const ScoreRow = ({ scorer, idx }: ScoreRowProps) => {
  const theme = useTheme();

  const pointsFormatted = useNumberFormatter({
    notation: 'standard',
  }).format(scorer.points);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: '100%',
        flexGrow: 1,
      }}
    >
      <Box sx={SX_ROW_GROUP}>
        <WorkspacePremiumIcon sx={{ color: POSITION_TO_COLOR[Number(idx)] }} />
        <Typography
          sx={{ mr: 3, whiteSpace: 'nowrap' }}
          color={theme.palette.text.secondary}
        >
          {scorer.name}
        </Typography>
      </Box>
      <Box sx={SX_ROW_GROUP}>
        <Typography
          sx={{ whiteSpace: 'nowrap' }}
          color={theme.palette.text.secondary}
        >{`${pointsFormatted} pts`}</Typography>
      </Box>
    </Box>
  );
};

export type LeaderboardScoreProps = {
  scorers: Scorer[];
};

export function LeaderboardScore({ scorers }: LeaderboardScoreProps) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', mr: 2 }}>
      {scorers && scorers.length > 0 ? (
        scorers.map((scorer, idx) => {
          return <ScoreRow key={scorer.id} scorer={scorer} idx={idx} />;
        })
      ) : (
        <div>loading</div>
      )}
    </Box>
  );
}
